export const COLOR_LIST = [
  {
    name: "デフォルトカラー",
    values: [
      { color: "#eb3333", text: "レッド", label: "red" },
      { color: "#fb7800", text: "オレンジ", label: "orange" },
      { color: "#fad30f", text: "イエロー", label: "yellow" },
      { color: "#179c81", text: "グリーン", label: "green" },
      { color: "#3282c9", text: "ブルー", label: "blue" },
      { color: "#9265ec", text: "パープル", label: "purple" },
    ],
  },
  {
    name: "ライトカラー",
    values: [
      { color: "#fa9696", text: "ライトレッド", label: "l_red" },
      { color: "#ffb26c", text: "ライトオレンジ", label: "l_orange" },
      { color: "#fce979", text: "ライトイエロー", label: "l_yellow" },
      { color: "#80cfbf", text: "ライトグリーン", label: "l_green" },
      { color: "#97c1e8", text: "ライトブルー", label: "l_blue" },
      { color: "#bfa3f7", text: "ライトパープル", label: "l_purple" },
    ],
  },
  {
    name: "ダークカラー",
    values: [
      { color: "#b20c0c", text: "ダークレッド", label: "d_red" },
      { color: "#cd4a00", text: "ダークオレンジ", label: "d_orange" },
      { color: "#d6a906", text: "ダークイエロー", label: "d_yellow" },
      { color: "#055c4a", text: "ダークグリーン", label: "d_green" },
      { color: "#094b87", text: "ダークブルー", label: "d_blue" },
      { color: "#5b2dbc", text: "ダークパープル", label: "d_purple" },
    ],
  },
  {
    name: "グレースケール",
    values: [
      { color: "#CCCCCC", text: "グレー 20%", label: "gray_20" },
      { color: "#B2B2B2", text: "グレー 30%", label: "gray_30" },
      { color: "#999999", text: "グレー 40%", label: "gray_40" },
      { color: "#7F7F7F", text: "グレー 50%", label: "gray_50" },
      { color: "#4C4C4C", text: "グレー 70%", label: "gray_70" },
      { color: "#000000", text: "ブラック", label: "black" },
    ],
  },
]

export default COLOR_LIST
